import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import Select2 from 'react-select/lib/Creatable';
import { api } from '@src/services/api';
import { checkLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Box, Modal } from '@src/components';
import Loading from '@src/components/UI/Loading';

export interface LocalProps {
    id: any;
    get: string;
    mount: string;
    action: "mount";
    onSuccess?: Function;
    onCancel?: Function;
}
export interface LocalState {
    battid: any;
    items: any;
    error: any;
}

// style
const style = css`
    form, article {
        ${mixin.form}
    }
`;

// component
export class DeviceMount extends React.Component<LocalProps, LocalState> {
    state = {} as LocalState;

    async componentWillMount() {
        const { action, get } = this.props;
        if (action === "mount") {
            const res = await api({
                url: get,
                method: 'get'
            });
            this.setState({
                items: res.data.data
            })
        }
    }

    async save( battid ) {
        const { id, mount, onSuccess } = this.props;
        try {
            const res = await api({
                url: mount,
                method: 'put',
                params: {
                    battid,
                    devid: id
                }
            });
            if (onSuccess) {
                onSuccess(res);
            }
        } catch(e) {
            this.setState({
                error: e.response.data
            })
        }
    }

    outputError() {
        const { error } = this.state;
        if (!error.errors) { return null; }
        const errors = Object.keys(error.errors).reduce( (acc, e) => {
            return [...acc, ...error.errors[e] ];
        }, [])
        return (
            <div className="errors">
                <div><strong>{error.message}</strong></div>
                <ul>
                    {errors.map( (v,k) => (
                        <li key={k}>{v}</li>
                    ) )}
                </ul>
            </div>
        )
    }
    
	// render
	render() {
        const { id, action, onCancel } = this.props;
        const { battid, items, error } = this.state;
        return (
            <Modal
                title={_(`${action}_device_title`, 'SettingsBattery') }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
            {action === "mount" &&
                <>
                {!items &&
                <Loading />
                }
                {items &&
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v.battid)}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ battid: formApi.getFormState().values.battid }); }) }
                        >
                            <div className="fields">
                                <article className="full">
                                    <label htmlFor="battid">{_('field_battid', 'SettingsBattery')}</label>
                                    <Select field={"battid"} id="battid" options={items.map( v => ({ value: v.id, label: `${v.serialno} ${v.description ? ` - ${v.description}` : ''}` }))} className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                    {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={!battid}>
                                    {_(`mount_device_btn`, 'SettingsBattery')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
                }
                </>
            }
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Actions/DeviceMount.tsx